import useMoney from '../../../../../../hooks/useMoney';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { FilterProps } from '../../../../../Crud/filters/sharedBetweenFilters/types';
import { IFilterHelperFactory } from '../../../../factories/filter-factory.types';

interface UseSelectedFilterChipParams {
  factory: IFilterHelperFactory;
  filter: FilterProps;
}

const useSelectedFilterChip = ({ factory, filter }: UseSelectedFilterChipParams) => {
  const { translate, isPortuguese, locale } = useTranslation();
  const { formatMoney } = useMoney();

  const chipLabel = factory.getChipLabel({ formatMoney, translate, isPortuguese, locale });
  const labelPrefix = `${filter.title}: `;
  const secondaryLabel = chipLabel?.startsWith(labelPrefix)
    ? chipLabel.slice(labelPrefix.length)
    : chipLabel;

  const title = factory.getFriendlyLabel({ formatMoney, isPortuguese, translate, locale });

  return {
    primaryLabel: filter.title,
    secondaryLabel,
    title,
    isLoading: factory.isLoading(),
    onClear: () => filter.cleanFilter?.(),
    removeAriaLabel: translate(LangEnum.GLOBAL_REMOVE),
  };
};

export default useSelectedFilterChip;
